import { render, staticRenderFns } from "./table-dri-edit.vue?vue&type=template&id=b04937de&scoped=true&"
import script from "./table-dri-edit.vue?vue&type=script&lang=ts&"
export * from "./table-dri-edit.vue?vue&type=script&lang=ts&"
import style0 from "./table-dri-edit.vue?vue&type=style&index=0&id=b04937de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04937de",
  null
  
)

export default component.exports